module.exports = `${require.publicPath}banner-img01.7861510d.png`;